import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarHeadlineComponent } from "./bar-headline.component";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BarHeadlineComponent],
  exports: [BarHeadlineComponent]
})
export class BarHeadlineModule { }
